import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PublicationDetailProvider } from "./context/publication-detail-context";
import { PublicationDetailComponent } from "./publication-detail-component";

export function PublicationDetailFactory() {
    return (
        <BaseLayoutFactory>
            <PublicationDetailProvider>
                <PublicationDetailComponent />
            </PublicationDetailProvider>
        </BaseLayoutFactory>
    );
}
